import React from "react";
import Applicant from "./Applicant";
import CoApplicant from "./CoApplicant";
import Property from "./Property";
import Costing from "./Costing";
import Payment from "./Payment";
import { bool } from "prop-types";
import ReviewAndSubmit from "./ReviewAndSubmit";
import { ConfigProvider } from "antd";
import BuilderPayment from "./BuilderPayment";
import Collection from "./Collection";
import { getAntdTheme } from "hooks/antdTheme";
import { useMaterialUIController } from "context";

const StepContent = ({
  id,
  propertyConfig,
  propertyList,
  setValue,
  current,
  ocfDisplayId,
  paymentFields,
  addPayment,
  removePayment,
  bookingFormFields,
  addBookingForm,
  removeBookingForm,
  isFormLocked,
  ocf,
  getOcfDetails,
}) => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  switch (current) {
    case 0:
      return (
        <ConfigProvider componentDisabled={isFormLocked} theme={getAntdTheme(darkMode)}>
          <Applicant id={id} ocfDisplayId={ocfDisplayId} />
        </ConfigProvider>
      );
    case 1:
      return (
        <ConfigProvider componentDisabled={isFormLocked} theme={getAntdTheme(darkMode)}>
          <CoApplicant id={id} ocfDisplayId={ocfDisplayId} />
        </ConfigProvider>
      );
    case 2:
      return (
        <ConfigProvider componentDisabled={isFormLocked} theme={getAntdTheme(darkMode)}>
          <Property
            propertyList={propertyList}
            setValue={setValue}
            propertyConfig={propertyConfig}
            //   watch={watch}
            ocfDisplayId={ocfDisplayId}
            ocf={ocf}
          />
        </ConfigProvider>
      );
    case 3:
      return (
        <ConfigProvider componentDisabled={isFormLocked} theme={getAntdTheme(darkMode)}>
          <Costing
            ocfDisplayId={ocfDisplayId}
            bookingFormFields={bookingFormFields}
            addBookingForm={addBookingForm}
            removeBookingForm={removeBookingForm}
          />
        </ConfigProvider>
      );
    case 4:
      return (
        <ConfigProvider componentDisabled={isFormLocked} theme={getAntdTheme(darkMode)}>
          <Payment
            paymentFields={paymentFields}
            addPayment={addPayment}
            removePayment={removePayment}
            propertyConfig={propertyConfig}
            ocfDisplayId={ocfDisplayId}
          />
        </ConfigProvider>
      );
    case 5:
      return (
        <ConfigProvider theme={getAntdTheme(darkMode)} >
          <ReviewAndSubmit ocf={ocf} ocfId={id} />
        </ConfigProvider>
      );
    case 6:
      return (
        <ConfigProvider theme={getAntdTheme(darkMode)}>
          <BuilderPayment ocf={ocf} ocfId={id} getOcfDetails={getOcfDetails} />{" "}
        </ConfigProvider>
      );
    case 7:
      return (
        <ConfigProvider theme={getAntdTheme(darkMode)}>
          <Collection ocf={ocf} ocfId={id} getOcfDetails={getOcfDetails} />{" "}
        </ConfigProvider>
      );
    default:
      return null;
  }
};

export default StepContent;
